<template>
  <v-navigation-drawer
    :value="value"
    :permanent="$vuetify.breakpoint.smAndUp"
    :mini-variant="$vuetify.breakpoint.smAndUp && miniVariant"
    :width="$vuetify.breakpoint.smAndUp ? '260' : '300'"
    app
    mini-variant-width="70"
    class="ProfileNavigationDrawer"
    @input="$emit('input', $event)"
  >
    <v-list
      :nav="miniVariant"
      :rounded="!miniVariant"
    >
      <v-badge
        v-for="item in items"
        :key="item.name"
        :value="!!item.badge"
        :content="item.badge"
        color="red"
        overlap
        offset-x="20"
        offset-y="20"
        class="d-flex"
      >
        <v-list-item
          :to="item.route"
          color="primary"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item>
      </v-badge>
    </v-list>

    <template v-if="activeChildProfile" v-slot:append>
      <v-list nav>
        <ChildProfileDrawerMenu />
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

const noActiveProfileItems = [
  {
    name: 'Home',
    icon: 'home',
    route: { name: 'main-menu' },
  },
  {
    name: 'Switch',
    icon: 'switch_account',
    route: { name: 'switch-child' },
  },
  {
    name: 'Play',
    icon: 'sports_esports',
    route: { name: 'newgame' },
  },
];

export default {
  name: 'ProfileNavigationDrawer',
  components: {
    ChildProfileDrawerMenu: () => import('@/components/profiles/navigation-drawer/ChildProfileDrawerMenu'),
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    miniVariant: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('children', [
      'activeChildProfile',
    ]),
    ...mapGetters('assignments', [
      'runningAssignments',
    ]),
    items() {
      if (this.activeChildProfile) {
        // TODO implement better synchronization with server to always keep realtime statuses
        return [
          {
            name: 'Home',
            icon: 'home',
            route: { name: 'main-menu' },
          },
          {
            name: 'Profile',
            icon: 'account_circle',
            route: { name: 'profile' },
          },
          {
            name: 'Switch',
            icon: 'switch_account',
            route: { name: 'switch-child' },
          },
          {
            name: 'Messages',
            icon: 'question_answer',
            route: { name: 'profile-chats' },
          },
          {
            name: 'Assignments',
            icon: 'assignment',
            badge: this.runningAssignments.length,
            route: { name: 'profile-assignments' },
          },
          {
            name: 'Classes',
            icon: 'groups_2',
            route: { name: 'profile-classes' },
          },
          {
            name: 'Academic success',
            icon: 'grading',
            route: { name: 'profile-grades' },
          },
          {
            name: 'Play',
            icon: 'sports_esports',
            route: { name: 'game-type-picker' },
          },
        ];
      }
      return noActiveProfileItems;
    },
  },
};
</script>
